import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit, Optional, Inject, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { convertToNgbDate, datePickerMinDate, noWhitespaceInRequiredValidator } from '../../../shared/constants';
import { noop } from 'jquery';
import { NavbarComponent } from '../../../navbar/navbar.component';
import Swal from 'sweetalert2';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { environment } from '../../../../environments/environment';
import moment from 'moment';
import { catchError, map, of, startWith, switchMap, timer } from 'rxjs';
import { addDays } from 'date-fns';

@Component({
	selector: 'app-leave-form',
	templateUrl: './leave-form.component.html',
	styleUrl: './leave-form.component.scss'
})
export class LeaveFormComponent {
	File_Storage_URL = environment.File_Storage_URL;
	isDate(value) {
		return Object.prototype.toString.call(value) === '[object Date]';
	}
	days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
	moduleForm: FormGroup = this.formBuilder.group({
		emp_code: [null, [Validators.required]],
		from_date: [null, [Validators.required]],
		to_date: [null, [Validators.required]],
		type: [null, [Validators.required]],
		reason: [null, [Validators.required]],
		is_approved: [false],
		line_items: this.formBuilder.array([])
	});
	showLoader = false;
	pageLoading1 = false;
	uId: any = null;
	deleted: any[] = [];
	typeList: any[] = [];
	@Input() userList: any[] = [];
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	formSubmitted = false;
	details: any = null;
	minDate = datePickerMinDate;
	minDateInRow: any = null;
	maxDateInRow: any = null;
	modalId = "leaveModal" + this.getRandom5DigitNumber();
	isAssignee = true;
	getRandom5DigitNumber() {
		return Math.floor(Math.random() * 90000) + 10000;
	}

	constructor(private cd: ChangeDetectorRef, private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.getLeaveTypes();
	}

	onFromDateSelect() {
		const from_date = this.f.from_date.value;
		if (!from_date || !this.isDate(from_date)) {
			return;
		}
		this.minDateInRow = convertToNgbDate(from_date)
		this.autoCreateRows();
	}

	onToDateSelect() {
		const to_date = this.f.to_date.value;
		if (!to_date || !this.isDate(to_date)) {
			return;
		}
		this.maxDateInRow = convertToNgbDate(to_date);
		this.autoCreateRows();
	}

	autoCreateRows() {
		const from_date = this.f.from_date.value;
		const to_date = this.f.to_date.value;
		if (
			/* !this.uId &&
			!this.details && */
			from_date &&
			this.isDate(from_date) &&
			to_date &&
			this.isDate(to_date)
		) {
			let len = this.get_rows.controls.length;
			for (let i = 0; i < len; i++) {
				let id = this.get_rows.controls[i].get("id")?.value;
				if (id) {
					this.deleted.push(id);
				}
			}
			this.get_rows.clear();
			const startDate = new Date(from_date);
			const endDate = new Date(to_date);
			let current = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
			while (current <= endDate) {
				this.addRow();
				this.get_rows.controls[this.get_rows.length - 1].get("date")?.setValue(new Date(current));
				current.setDate(current.getDate() + 1);
			}
		}
	}

	initForm(obj: any) {
		this.uId = obj.id || null;
		this.f.from_date.valueChanges.pipe(startWith(this.f.from_date.value)).subscribe(_ => this.onFromDateSelect());
		this.f.to_date.valueChanges.pipe(startWith(this.f.to_date.value)).subscribe(_ => this.onToDateSelect());
		if (this.uId) {
			this.details = obj;
			if (this.details.emp_code.emp_code) {
				this.navbar.getValueFromUserList(this.details.emp_code.emp_code, "emp_code").then((val) => {
					this.f.emp_code.setValue(val);
				});
			}
			this.f.from_date.setValue(this.apiService.getDateFromDateString(this.details.from_date, 'DD-MM-YYYY'), { emitEvent: false });
			this.f.to_date.setValue(this.apiService.getDateFromDateString(this.details.to_date, 'DD-MM-YYYY'), { emitEvent: false });
			this.f.type.setValue(this.details.type);
			this.f.reason.setValue(this.details.reason);
			this.f.is_approved.setValue(this.details.is_approved);
			let line_items: any = this.details.line_items;
			let len = line_items.length;
			for (let i = 0; i < len; i++) {
				this.addRow();
				this.get_rows.controls[i].get("id")?.setValue(line_items[i].id);
				this.get_rows.controls[i].get("is_half")?.setValue(line_items[i].is_half);
				this.get_rows.controls[i].get("date")?.setValue(this.apiService.getDateFromDateString(line_items[i].date, 'DD-MM-YYYY'));
			}
		} else {
			this.resetForm();
			if (this.navbar.hasLeaveAccess() && obj.emp_code) {
				this.f.emp_code.setValue(obj.emp_code);
			} else {
				this.f.emp_code.setValue(this.navbar.user.emp_code);
			}
			this.f.is_approved.setValue(false);
			this.formSubmitted = false;
			this.uId = null;
		}
		if (!this.navbar.hasLeaveAccess()) {
			this.f.is_approved.disable();
			this.f.emp_code.disable();
		} else {
			this.f.is_approved.enable();
			this.f.emp_code.enable();
		}
		this.isAssignee = obj.isAssignee;
		if (this.isAssignee) {
			this.f.emp_code.disable();
			this.f.is_approved.disable();
		}
		this.openModal();
		/* setTimeout(() => {
			
		}, 500); */
	}

	get f() { return this.moduleForm.controls; }

	get get_rows() {
		return this.moduleForm.controls['line_items'] as FormArray;
	}

	addRow() {
		const form = this.formBuilder.group({
			id: [null],
			date: [null, [Validators.required], this.holidayValidation()],
			is_half: [false]
		});
		this.get_rows.push(form);
	}

	deleteRow(index: number) {
		let id = this.get_rows.controls[index].get("id")?.value;
		if (id) {
			this.deleted.push(id);
		}
		this.get_rows.at(index).markAsUntouched();
		this.get_rows.at(index).updateValueAndValidity();
		this.get_rows.removeAt(index);
	}

	holidayValidation = (time: number = 500) => {
		return (input: FormControl) => {
			return timer(time).pipe(switchMap(() => this.apiService.checkHoliday(this.getPayloadForHolidayValidation(input.value))), map(res => {
				return null;
			}), catchError((e) => {
				return of({ holiday: true });
			})
			);
		};
	};

	getPayloadForHolidayValidation(date: any) {
		return {
			date: this.apiService.getDateStringFromDate(date, 'YYYY-MM-DD')
		}
	}

	clearForm() {
		this.uId = null;
		this.resetForm();
		this.formSubmitted = false;
		this.cleared.emit();
		$("#" + this.modalId).modal("hide");
	}

	resetForm() {
		this.get_rows.clear();
		this.moduleForm.reset();
		this.deleted = [];
	}

	openModal() {
		$("#" + this.modalId).modal("show");
	}

	getLeaveTypes() {
		this.apiService.getAllLeaveTypes().subscribe({
			next: (data: any) => {
				this.typeList = data;
			}, error: (error) => { }
		});
	}

	saveData() {
		this.formSubmitted = true;
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			emp_code: this.f.emp_code.value,
			from_date: this.apiService.getDateStringFromDate(this.f.from_date.value, 'YYYY-MM-DD'),
			to_date: this.apiService.getDateStringFromDate(this.f.to_date.value, 'YYYY-MM-DD'),
			type: this.f.type.value,
			reason: this.f.reason.value,
			is_approved: this.f.is_approved.value,
			deleted: this.deleted
		};
		let line_items: any = [];
		let len = this.get_rows.controls.length;
		if (!len) {
			this.toastr.info("No leaves added", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		for (let i = 0; i < len; i++) {
			let line_item: any = {
				date: this.apiService.getDateStringFromDate(this.get_rows.controls[i].get("date")?.value, 'YYYY-MM-DD'),
				is_half: this.get_rows.controls[i].get("is_half")?.value
			}
			let id = this.get_rows.controls[i].get("id")?.value;
			if (id) {
				line_item["id"] = id;
			}
			line_items.push(line_item);
		}
		data.line_items = line_items;
		if (this.uId) {
			data.id = this.uId;
		}
		this.showLoader = true;
		this.apiService.createUpdateLeave(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.cd.detectChanges();
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				this.cd.detectChanges();
				if (error.status == 401) { return }
				let errorMsg = error.error;
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	showError2(index: number, field: string) {
		let f: any = this.get_rows.controls[index].get(field);
		if (f.invalid && (this.formSubmitted || f.touched || f.dirty)) {
			return true;
		}
		return false;
	}

	showError3(index: number, field: string) {
		let f: any = this.get_rows.controls[index].get(field);
		if (f.invalid) {
			return true;
		}
		return false;
	}

	getRowDateString(date: any) {
		try {
			return this.apiService.getDateStringFromDate(date, 'YYYY-MM-DD');
		} catch (error) {
			return date;
		}
	}

	getWeekDay(date: any) {
		return this.days[date.getDay()];
	}

	getDateClass(index: number) {
		let day: any = null;
		try {
			day = this.get_rows.controls[index].get("date")?.value.getDay();
		} catch (error) { }
		if (day == 0 || day == 6 || this.showError3(index, 'date')) {
			return "text-danger";
		} else {
			return "text-dark";
		}
	}

	getDays() {
		let days = 0;
		let len = this.get_rows.controls.length;
		for (let i = 0; i < len; i++) {
			if (this.get_rows.controls[i].get("is_half")?.value) {
				days += 0.5;
			} else {
				days += 1;
			}
		}
		let txt = days > 1 ? " days" : " day"
		return "Request leave for " + days + txt;
	}
}
